import { render, staticRenderFns } from "./Exports.vue?vue&type=template&id=8d027978&"
import script from "./Exports.vue?vue&type=script&lang=js&"
export * from "./Exports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports